import Axios from 'axios';
 
const COMMISSION = '/commission';
const COMMISSION_TRANSACTION='/commission_transaction'

export default {

  //COMMISSION
  getAllCommissions() {
    return Axios.get(COMMISSION);
  },
 
  getCommission(id) {
    return Axios.get(`${COMMISSION}/${id}`);
  },
 
  createCommission(data) {
    return Axios.post(COMMISSION, data);
  },
 
  updateCommission(id, data) {
    return Axios.put(`${COMMISSION}/${id}`, data);
  },
 
  deleteCommission(id) {
    return Axios.delete(`${COMMISSION}/${id}`);
  },
 
  getCommissionsByUser(user_external_id){
    return Axios.get(`${COMMISSION}/getByUser/${user_external_id}`);
  },

  
  //COMMISSION TRANSACTIONS
  getAllCommissionTransactions() {
    return Axios.get(COMMISSION_TRANSACTION);
  },
 
  getCommissionTransaction(id) {
    return Axios.get(`${COMMISSION_TRANSACTION}/${id}`);
  },
 
  createCommissionTransaction(data) {
    return Axios.post(COMMISSION_TRANSACTION, data);
  },
 
  updateCommissionTransaction(id, data) {
    return Axios.put(`${COMMISSION_TRANSACTION}/${id}`, data);
  },
 
  deleteCommissionTransaction(id) {
    return Axios.delete(`${COMMISSION_TRANSACTION}/${id}`);
  },
 
  getTransactionsByCommission(commission_external_id){
    return Axios.get(`${COMMISSION_TRANSACTION}/getByCommission/${commission_external_id}`);
  },

  deleteTransactionsByCommission(commission_external_id) {
    return Axios.delete(`${COMMISSION_TRANSACTION}/deleteByCommission/${commission_external_id}`);
  },

  bulkCreateCommissionTransaction(data) {
    return Axios.post(`${COMMISSION_TRANSACTION}/bulkCreate`, data);
  },
}